import { ReactNode } from 'react';

import i18n from '../utils/i18n';

type ErrorCodeRecord = Record<string, string | ReactNode>;

interface ErrorCodeList {
    project: ErrorCodeRecord;
}

const errorCodeList: ErrorCodeList = {
    project: {
        SPECTRUM_MIX_NOT_EXISTS: i18n('spectrum_mix_not_exists'),
        SPECTRUM_MIX_NOT_AVAILABLE: i18n('spectrum_mix_not_available'),
        SPECTRUM_MIX_NOT_SET: i18n('spectrum_mix_not_set'),
        TARGET_SPECTRUM_NOT_EXISTS: i18n('target_spectrum_not_exists'),
        RECIPE_NOT_SET: i18n('recipe_not_set'),
        RECIPE_NOT_EXISTS: i18n('recipe_not_exists')
    }
};

export default errorCodeList;
